import React from "react";
import "./skeleton.css"; // Ensure this file contains the pulse animation

const InputSkeleton = ({ width = "100%", height = "37px", borderRadius = "6px" }) => {
  return (
    <div
      className="skeleton-label"
      style={{
        width,
        height,
        borderRadius,
      }}
    ></div>
  );
};

export default InputSkeleton;
